export { default } from './ModalConfirmActivationGIGR.jsx';
